/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Is_LockedInputs */



/**
* | output |
* | --- |
* | "Project is Locked" |
*
* @param {Project_Is_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_is_locked = /** @type {((inputs?: Project_Is_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Is_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le projet est verrouillé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt ist gesperrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il progetto è bloccato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект заблокирован")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proyecto está bloqueado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已锁定。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトはロックされています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट लॉक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O projeto está bloqueado.")
	return /** @type {LocalizedString} */ ("Project is Locked")
});